module.exports = __webpack_public_path__ + "accb10ea3e9abe82a379023a50cbe683.pdf";